import { subDays } from 'date-fns';
import { Message } from '../../type';

export const is240DaysOld = (date: Date) => {
  const last240Days = subDays(new Date(), 240);
  return date <= last240Days;
};

export const filterLast240Days = (messages: Message[]): Message[] => {
  const last240Days = subDays(new Date(), 240);
  return messages.filter(
    (message) => message.createdDate.toDate() > last240Days,
  );
};
